class FormatNestedTranslations {
  constructor() {
    this.name = "postProcessorNested";
    this.type = "postProcessor";
  }

  extractGroups = (value) => {
    let regex = /(\[\[([^\]]+),([^\]]+)\]\])+/g;
    return [...value.matchAll(regex)];
  };

  process = (value) => {
    let groups = this.extractGroups(value);
    if (groups == null) return value;
    if (groups.length < 1) return value;
    let val = value;
    for (const idx in groups) {
      let translated = groups[idx][2];
      let method = groups[idx][3];
      if (method === "lowercase") {
        let lower = translated.toLowerCase();
        val = val.replace(groups[idx][0], lower);
      } else {
        val = val.replace(groups[idx][0], translated);
      }
    }
    return val;
  };
}

export default FormatNestedTranslations;
